import React from 'react';

/**
 * Normalise un caractère en supprimant les accents et diacritiques
 * @param {string} char - Le caractère à normaliser
 * @returns {string} - Le caractère normalisé (sans accents)
 */
const normalizeChar = (char) => {
  return char
    .normalize('NFD') // Décompose les caractères accentués (é -> e + ´)
    .replace(/[\u0300-\u036f]/g, '') // Supprime les diacritiques (accents, cédilles, etc.)
    .toLowerCase();
};

/**
 * Composant qui colore chaque caractère d'un texte selon une matrice de couleurs
 * @param {string} text - Le texte à colorer
 * @param {Object} matrice - L'objet matrice contenant lettres_couleurs et chiffres_couleurs
 */
const ColoredText = ({ text, matrice }) => {
  if (!text || !matrice) {
    return <>{text}</>;
  }

  const lettresCouleurs = matrice.lettres_couleurs || {};
  const caracteresSpeciauxCouleurs = matrice.caracteres_speciaux_couleurs || {};
  const chiffresCouleurs = matrice.chiffres_couleurs || {};

  return (
    <>
      {text.split('').map((char, index) => {
        const charUpper = char.toUpperCase();
        const charLower = char.toLowerCase();
        const normalizedChar = normalizeChar(char);
        const normalizedCharUpper = normalizedChar.toUpperCase();
        
        // Vérifier si c'est une lettre avec couleur
        // D'abord essayer avec le caractère original, puis avec le caractère normalisé
        let color = null;
        if (caracteresSpeciauxCouleurs[char]) {
          color = caracteresSpeciauxCouleurs[char];
        } else if (lettresCouleurs[charUpper] || lettresCouleurs[charLower]) {
          color = lettresCouleurs[charUpper] || lettresCouleurs[charLower];
        } else if (normalizedChar && (lettresCouleurs[normalizedCharUpper] || lettresCouleurs[normalizedChar])) {
          // Utiliser la couleur du caractère normalisé (sans accent)
          color = lettresCouleurs[normalizedCharUpper] || lettresCouleurs[normalizedChar];
        }
        // Vérifier si c'est un chiffre avec couleur
        else if (chiffresCouleurs[char]) {
          color = chiffresCouleurs[char];
        }

        // Si le caractère a une couleur, l'appliquer avec un span
        if (color) {
          return (
            <span key={index} style={{ color }}>
              {char}
            </span>
          );
        }

        // Sinon, retourner le caractère tel quel (garde la couleur CSS par défaut)
        return <React.Fragment key={index}>{char}</React.Fragment>;
      })}
    </>
  );
};

export default ColoredText;
